// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ygukY","text":"styles_text__N8-Lv","arrowWrapper":"styles_arrowWrapper__9mSFX"};